import VueMoney from 'v-money';
import VueRouter from 'vue-router';
import VueBus from '../plugins/bus';
import VueNotify from '../plugins/notify';
import { install } from 'vue-demi';
import { PiniaVuePlugin } from 'pinia';
import { mask } from 'vue-the-mask';
import Vue from 'vue';

function createVueInstance() {
    install(Vue);
    Vue.use(PiniaVuePlugin);
    // use components
    Vue.use(VueRouter);

    Vue.use(VueMoney, {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false
    });

    Vue.use(VueBus);
    Vue.use(VueNotify);

    // directives
    Vue.directive('mask', mask);

    // initialize devtools when not in production
    // if (__DEVELOPMENT__ || __STAGE__) {
    Vue.config.devtools = process.env.NODE_ENV !== 'production';
    Vue.config.productionTip = false;
    // }

    // return Vue for further setup
    return Vue;
}

export default createVueInstance;
